export function commontrackEvent(
	event_name,
	event_category,
	label_name,
	param,
) {
	// `window` 객체를 사용하여 vue-gtag를 직접 참조
	if (window && window.$gtag) {
		window.$gtag.event(event_name, {
			event_category: event_category, // 이벤트 카테고리 (예: 'User Actions')
			event_label: label_name, // 이벤트 라벨 (예: 'Main Button Click')
			value: param, // (선택 사항) 이벤트 값
		});
	} else {
		if (process.env.VUE_APP_BUILD_MODE === 'DEV' ) {
			console.error('Google Analytics is not properly initialized.');
		}
	}
}

export function customUserTrackEvent(event_name, user_id) {
	if (window && window.$gtag) {
		window.$gtag.event(event_name, {
			user_id: user_id,
		});
	} else {
		if (process.env.VUE_APP_BUILD_MODE === 'DEV' ) {
			console.error('Google Analytics is not properly initialized.');
		}
	}
}

export function customTrackEvent(event_name, params) {
	if (window && window.$gtag) {
		window.$gtag.event(event_name, params);
	} else {
		if (process.env.VUE_APP_BUILD_MODE === 'DEV' ) {
			console.error('Google Analytics is not properly initialized.');
		}
	}
}
